<template>
  <div class="marketing-block">
    <div v-if="bare == true" class="panel">
      <div class="full">
        <component :is="embeddedComponent"
          :view="view"
          v-bind="embeddedProps" />
      </div>
    </div>
    <div v-else class="panel">
      <div v-if="layoutType == 'right'" class="panel-half image-left">
        <img :src="panelAsset" :alt="$t(`${view}.${name}_PANEL_IMG_ALT`)"/>
      </div>
      <div :class="layoutType === 'center' ? 'full' : 'panel-half content'">
        <h2 v-html="$t(`${view}.${name}_PANEL_HEADING`)"></h2>
        <p v-html="$t(`${view}.${name}_PANEL_BODY`)"></p>
        <domain-availability-checker v-if="embed == 'domain-availability-checker'" />
        <div v-if="layoutType == 'center'">
          <img :src="panelAsset" :alt="$t(`${view}.${name}_PANEL_IMG_ALT`)"/>
        </div>
        <div>
          <template v-if="clickHandler">
            <md-button v-if="hasCTA" @click="handleCustomClick(clickHandler)" class="md-raised md-primary">{{$t(`${view}.${name}_PANEL_CTA`)}}</md-button>
          </template>
          <template v-else>
            <md-button :to="{path, query}" v-if="hasCTA" class="md-raised md-primary">{{$t(`${view}.${name}_PANEL_CTA`)}}</md-button>
          </template>
        </div>
      </div>
      <div v-if="layoutType == 'left'" class="panel-half image-right">
        <img :src="panelAsset" :alt="$t(`${view}.${name}_PANEL_IMG_ALT`)"/>
      </div>
    </div>
  </div>
</template>

<script>
import {PANEL_LAYOUTS, LEGACY_SERVICE_MAPPING} from 'app-constants'
import Vue from 'vue'
import style from 'styles/marketing-block.scss'
import DomainAvailabilityChecker from 'brave-domain/components/domain-availability-checker'
import CardContainer from 'brave-cards/components/card-container'
import { mapActions } from 'vuex'
import login from 'brave-authentication/components/login'
import {DOMAINS_CHECKOUT_URL,} from 'brave-api/constants'

var vueSmoothScroll = require('vue-smoothscroll');
Vue.use(vueSmoothScroll);

export default {
  data () {
    if (!this.bare) {
      let assetName = (this.assetName)
          ? this.assetName
          : this.name
      // TODO: Refactor to allow for different types of image filetypes (gif, png, jpeg, webp, etc)
      let defaultImageType = this.assetType ? this.assetType : 'png';
      let panelAsset = require(`assets/img/${this.view}/${assetName.toLowerCase()}.${defaultImageType}`)
      let layoutType = '';
      switch (this.layout) {
        case PANEL_LAYOUTS.CONTENT_LEFT:
          layoutType = 'left';
          break;
        case PANEL_LAYOUTS.CONTENT_RIGHT:
          layoutType = 'right';
          break;
        case PANEL_LAYOUTS.CONTENT_CENTER:
          layoutType = 'center';
          break;
        case PANEL_LAYOUTS.CONTENT_ONLY:
          layout
        default:
          throw new Error(`Invalid layout type passed into marketing-block! Tried to pass ${this.layout} but it is invalid!`)
          break;
      }

      let path = (this.href)
        ? this.href
        : '/register'

      let embeddedComponent = null
      let legacyService = LEGACY_SERVICE_MAPPING[this.view]
      let query = (legacyService)
        ? { from: legacyService}
        : ''

      return {
        panelAsset,
        layoutType,
        legacyService,
        path,
        query,
        embeddedComponent
      }
    }

    let embeddedComponent = null
    if (this.embed.component == 'card-container') {
      embeddedComponent = CardContainer
    }

    return {embeddedComponent, embeddedProps: this.embed.props}
  },
  methods: {
    openLoginModal: function () {
      let props = {
        onSuccess: function (data) {

          let redirect = DOMAINS_CHECKOUT_URL.replace('$CURRENT_PUB$', data.response.pub)
          window.location.assign(redirect)
        }
      }
      this.$store.dispatch('pushModal', {component: login, props})
    },
    handleCustomClick: function (data) {
      if (data.type == 'smoothScroll') {
        this.$SmoothScroll(document.querySelector(data.target).offsetTop - 50, 2000);
      }

    }
  },
  components: {
    'panel-image': { // TODO: figure out why this doesnt want to pre-render
      template: '<div><img :src="panelAsset" :alt="$t(`${view}.${name}_PANEL_IMG_ALT`)"/></div>',
      props: ['name', 'panelAsset', 'view']
    },
    'domain-availability-checker': DomainAvailabilityChecker

  },
  props: [
    'name',
    'assetName',
    'assetType',
    'layout',
    'view',
    'hasCTA',
    'clickHandler',
    'href',
    'bare',
    'embed' // TODO: find out a way to dynamically import embeds
  ]
}
</script>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/panel-block.vue